import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ 'hiddenDiv' ]

  show() {
    this.hiddenDivTarget.classList.toggle('hidden');
  }
}
